import React from "react";
import UserNav from "./UserNav";
import UserNavItem from "./UserNavItem";
import MoreUserBtn from "./MoreUserBtn";
import SectionHeading from "../sectionHeading/SectionHeading";
import Spacing from "../common/spacing/Spacing";
import Separator from "../common/seperator/Separator";
import Cta from "../cta/Cta";
import Button from "../button/Button";
import Nav from "./Nav";
import UserSvg from "./../svg/UserSvg";
import "./sidebar.scss";

const Sidebar = () => {
  return (
    <div className="sidebar_wrap">
      <Spacing height={20} />
      <Nav />
      <Spacing height={20} />
      <Separator />
      <Spacing height={26} />
      <Cta
        title="Join 50k+ Brabblers..."
        subtitle="Sign in to like podcasts, comment, and subscribe."
      >
        <Button href="/" varient="style2">
          <UserSvg /> Sign In
        </Button>
      </Cta>
      <Spacing height={30} />
      <Separator />
      <Spacing height={30} />
      <SectionHeading varient="style1" title="SUBCRIPTIONS" />
      <Spacing height={12} />
      <UserNav>
        <UserNavItem imgUrl="/images/sidebar_user_1.png">
          Joe Roogan Experience
        </UserNavItem>
        <UserNavItem imgUrl="/images/sidebar_user_2.png">
          Team Croco Airwolf
        </UserNavItem>
        <UserNavItem imgUrl="/images/sidebar_user_3.png">
          Another Podcast
        </UserNavItem>
        <UserNavItem imgUrl="/images/sidebar_user_5.png">
          Naval Expo Design
        </UserNavItem>
      </UserNav>
      <Spacing height={25} />
      <Separator />
      <Spacing height={30} />
      <SectionHeading varient="style1" title="PEOPLE YOU FOLLOW" />
      <Spacing height={12} />
      <UserNav>
        <UserNavItem imgUrl="/images/sidebar_user_1.png" variant="style1">
          Joe Roogan Experience
        </UserNavItem>
        <UserNavItem imgUrl="/images/sidebar_user_2.png" variant="style1">
          Team Croco Airwolf
        </UserNavItem>
        <UserNavItem imgUrl="/images/sidebar_user_3.png" variant="style1">
          Another Podcast
        </UserNavItem>
        <UserNavItem imgUrl="/images/sidebar_user_4.png" variant="style1">
          Whatever Show
        </UserNavItem>
        <MoreUserBtn>Show 27 More</MoreUserBtn>
      </UserNav>
    </div>
  );
};

export default Sidebar;
